import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {Store} from '@ngxs/store';
import {OrgsState} from '../+state/orgs/state';

export const orgInterceptor: HttpInterceptorFn = (req, next) => {
  const orgId = inject(Store).selectSnapshot(OrgsState.selectedOrg);
  if (!orgId) {
    return next(req);
  }
  const reqClone = req.clone({
    headers: req.headers.set('X-Org-Id', orgId)
  });

  return next(reqClone);
};
